import Cookies from 'universal-cookie';

const cookies = new Cookies();

export function getToken() {
  return cookies.get('TOKEN');
}

export function setToken(token) {
  return cookies.set('TOKEN', token, { path: '/' });
}

export function removeToken() {
  return cookies.remove('TOKEN', { path: '/' });
}

export function setCurrentOnboardingStep(step, uid) {
  const key = uid ? `ONBOARDING_STEP_${uid}` : 'ONBOARDING_STEP';
  return cookies.set(key, step, { path: '/' });
}

export function getCurrentOnboardingStep(uid) {
  const key = uid ? `ONBOARDING_STEP_${uid}` : 'ONBOARDING_STEP';
  return cookies.get(key);
}

export function removeCurrentOnboardingStep(uid) {
  const key = uid ? `ONBOARDING_STEP_${uid}` : 'ONBOARDING_STEP';
  return cookies.remove(key, { path: '/' });
}
